import { PayloadAction } from "@reduxjs/toolkit";
import { ContractFunnel } from "../../../types/interfaces";
import { PricingState } from "../pricingSlice";
import { createContractFunnelHash } from "../utils/createContractFunnelHash";

export const contractReducers = {
  updateAllContractFunnelsItem: (
    state: PricingState,
    action: PayloadAction<{
      itemId: string;
      type: 'variable' | 'fee';
      newValue: number;
    }>
  ) => {
    const { itemId, type, newValue } = action.payload;
    state.contractFunnels.forEach(contractFunnel => {
      if (type === 'variable') {
        const variable = contractFunnel.variables.find(v => v.variableValueId === itemId || v.variableRefId === itemId);
        if (variable) {
          variable.value = newValue;
        }
      } else if (type === 'fee') {
        const fee = contractFunnel.fees?.find(f => f.code === itemId);
        if (fee) {
          fee.value = newValue;
        }
      }
    });

    state.contractFunnels.forEach(contractFunnel => {
      contractFunnel.hash = ''
      contractFunnel.hash = createContractFunnelHash(contractFunnel)

      const updateContractFunnel = state.updatedContractFunnels.find(
        cf => cf.id === contractFunnel.id && cf.contractIdentifier === contractFunnel.contractIdentifier
      );

      const existingUpdatedIndex = state.updatedContractFunnels.findIndex(
        cf => cf.id === contractFunnel.id && cf.contractIdentifier === contractFunnel.contractIdentifier
      );

      if (updateContractFunnel && updateContractFunnel.hash === contractFunnel.hash) {
        // Supprimer de updatedContractFunnels si identique à l'original
        state.updatedContractFunnels.splice(existingUpdatedIndex, 1);
      }
    });
  },


  // Action pour mettre à jour une fee ou variable dans un contractFunnel spécifique
  updateContractFunnelItem: (
    state: PricingState,
    action: PayloadAction<{
      contractFunnelId: string;
      contractIdentifier?: string;
      itemId: string;
      type: 'variable' | 'fee';
      newValue: number;
    }>
  ) => {
    const { contractFunnelId, contractIdentifier, itemId, type, newValue } = action.payload;

    // Chercher si l'item existe déjà dans updatedContractFunnels
    let existingUpdatedIndex = state.updatedContractFunnels.findIndex(
      ucf => ucf.id === contractFunnelId && ucf.contractIdentifier === contractIdentifier
    );

    let targetContractFunnel: ContractFunnel;

    if (existingUpdatedIndex !== -1) {
      // Utiliser l'existant dans updatedContractFunnels
      targetContractFunnel = state.updatedContractFunnels[existingUpdatedIndex];
    } else {
      // Chercher dans contractFunnels et créer une copie
      const originalContractFunnel = state.contractFunnels.find(
        cf => cf.id === contractFunnelId && cf.contractIdentifier === contractIdentifier
      );

      if (!originalContractFunnel) {
        console.error(`ContractFunnel with id ${contractFunnelId} and contract identifier ${contractIdentifier} not found`);
        return;
      }

      // Créer une copie profonde pour éviter les mutations
      targetContractFunnel = {
        ...originalContractFunnel,
        variables: originalContractFunnel.variables.map(v => ({ ...v })), // Copie profonde
        fees: originalContractFunnel.fees ? originalContractFunnel.fees.map(f => ({ ...f })) : undefined, // Copie profonde
        guarantees: originalContractFunnel.guarantees.map(g => ({ ...g })), // Copie profonde
      };

      state.updatedContractFunnels.push(targetContractFunnel);
      existingUpdatedIndex = state.updatedContractFunnels.length - 1;
    }

    // Mettre à jour la valeur
    if (type === 'variable') {
      const variable = targetContractFunnel.variables.find(
        v => v.variableValueId === itemId || v.variableRefId === itemId
      );
      if (variable) {
        variable.value = newValue;
        variable.warningMessage = undefined
      }
    } else if (type === 'fee') {
      const fee = targetContractFunnel.fees?.find(f => f.code === itemId);
      if (fee) {
        fee.value = newValue;
        fee.warningMessage = undefined
      }
    }

    targetContractFunnel.hash = ''
    targetContractFunnel.hash = createContractFunnelHash(targetContractFunnel)

    // Vérifier si le contractFunnel modifié est identique à l'original
    const originalContractFunnel = state.contractFunnels.find(
      cf => cf.id === contractFunnelId && cf.contractIdentifier === contractIdentifier
    );

    if (originalContractFunnel && originalContractFunnel.hash === targetContractFunnel.hash) {
      // Supprimer de updatedContractFunnels si identique à l'original
      state.updatedContractFunnels.splice(existingUpdatedIndex, 1);
    }
  },
  deleteUpdatedContractFunnel: (state: PricingState, action: PayloadAction<string>) => {
    const hash = action.payload
    state.updatedContractFunnels = [
      ...state.updatedContractFunnels.filter((contract) => contract.hash !== hash)
    ]
  },
}
